const listingSource = {
  USER_ENTRY: 1,
  SCRAPER: 3,
  INSTAGRAM: 3,
};

module.exports = listingSource;
